/**
 * Represents an error response from the API.
 */
export interface ApiError {
  success: false;
  error: string;
  details?: unknown;
}

/**
 * Represents a successful response from the API.
 */
export interface ApiSuccess<T> {
  success: true;
  data: T;
}

/**
 * Represents a response from the API.
 */
export type ApiResponse<T> = ApiSuccess<T> | ApiError;

/**
 * Represents a server error.
 */
export class ServerError extends Error {
  constructor(
    message: string,
    public statusCode: number = 500,
    public details?: unknown
  ) {
    super(message);
    this.name = "ServerError";
  }
}

/**
 * Thrown when a landing page slug conflicts with an existing slug in either the V1 or V2 table.
 */
export class SlugConflictError extends Error {
  constructor(message = "This slug is already taken. Please choose a different one.") {
    super(message);
    this.name = "SlugConflictError";
  }
}

/**
 * Checks if a response is an API error.
 */
export function isApiError(response: unknown): response is ApiError {
  return (
    typeof response === "object" &&
    response !== null &&
    "success" in response &&
    response.success === false &&
    "error" in response
  );
}
